import useRouter from "@stadium/hooks/lib/use-custom-route";
import { DEFAULT_COUNTRY } from "@stadium/helpers/country/constants";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCountry } from "@slices/country";
import { selectAllCountries } from "@stadium/redux-utils/selectors/configSelector";
import { useConfig } from "@stadium/hooks/lib/use-config";
import { getCountry } from "@selectors/country";
import { useStoreContext } from "@components/store/provider";

const useCountryChange = (countriesList) => {
  const { query, pathname, replace } = useRouter();
  const dispatch = useDispatch();
  const selectedCountry = useSelector(getCountry);

  const { countryCode, isNewRoute, lang } = useStoreContext();

  const allCountries = useConfig(selectAllCountries);
  const countries = countriesList || allCountries;

  const changeCountry = useCallback(
    (country) => {
      const updatedQuery = {
        ...query,
        countryCode: isNewRoute
          ? `${country.iso.toLowerCase()}-${lang}`
          : country.iso.toLowerCase(), // // countryCodenaming will be changed to localeCode once we switch to new routes directories completely
      };
      let updatedPathname = pathname;
      if (updatedPathname === "/" && updatedQuery.countryCode) {
        updatedPathname = "/[countryCode]";
      }
      Object.keys(updatedQuery).forEach((key) => {
        updatedPathname = updatedPathname.replace(`[${key}]`, updatedQuery[key]);
        delete updatedQuery[key];
      });
      replace({ pathname: updatedPathname, query: updatedQuery });
    },
    [pathname, query, replace],
  );

  useEffect(() => {
    const country =
      countries.find((country) => country.iso.toLowerCase() === countryCode) ||
      countries.find((country) => country.iso === DEFAULT_COUNTRY.iso);
    if (country?.iso && selectedCountry?.iso?.toLowerCase() !== country?.iso.toLowerCase()) {
      dispatch(setCountry(country));
    }
  }, [countryCode, countries, dispatch]);

  return {
    changeCountry,
  };
};

export default useCountryChange;
